var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"checkbox",attrs:{"label":_vm.label,"value":_vm.value,"color":"primary","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }